module.exports = __webpack_public_path__ + "static/assets/ddc0f358d6689675472ef9aad95dc698.gif";